import cx from "classnames";
import { ReactNode, useId } from "react";

import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";
import useDetectMobile from "hooks/useDetectMobile";
import useTitle from "hooks/useTitle";

import { IntegrationView } from "../../types";
import FiltersLayout from "./FiltersLayout";
import styles from "./styles.module.css";

type IntegrationsLayoutProps = {
  children: ReactNode;
  searchBar: ReactNode;
  integrations: IntegrationView[];
};

const IntegrationsLayout = ({ children, searchBar, integrations }: IntegrationsLayoutProps) => {
  const titleId = useId();
  const isMobile = useDetectMobile();

  useTitle("Integrations");

  return (
    <>
      <ViewHeader firstLevel>
        <Box justify="center" align="center" gap="medium">
          <ViewHeaderTitle id={titleId}>Integrations</ViewHeaderTitle>
        </Box>

        <ViewHeaderWrapper direction="row">
          {searchBar}
          <FiltersMobileTriggerButton />
        </ViewHeaderWrapper>
      </ViewHeader>
      <FiltersLayout titleId={titleId} integrations={integrations}>
        <Box className={cx(styles.integrationsWrapper, { [styles.mobile]: isMobile })}>
          {children}
        </Box>
      </FiltersLayout>
    </>
  );
};

export default IntegrationsLayout;
